import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import axios from "axios";
import { useEffect, useState } from "react";
import ImageCropper from "./components/home/ImageCropper";
import { BrowserRouter as Router, Route, useParams, useLocation } from "react-router-dom";
import Header from "./components/layout/Header";
import Sidebar from "./components/layout/SideMenu";
import Footer from "./components/layout/Footer";
import Home from "./components/home/Home";
import Login from "./components/Login";
import { connect } from "react-redux";
import { useTranslation } from 'react-i18next';
import { LanguageContext } from './components/contexts/LanguageContext';
import CreateBank from "./components/banks/CreateBank";
import CreateUsers from "./components/Admin/CreateUsers";
import CreateJobs from "./components/jobs/createJobs"
import UnverifiedUsers from "./components/UnverifiedUsers";
import Jobs from "./components/jobs/jobs"
import CreateBranch from "./components/branches/CreateBranch";
import "./stylesheets/animations.css";
import CreateCategory from "./components/categories/CreateCategory";
import CheckCategories from "./components/categories/CheckCategories";
import Search from "./components/search";
import CheckSignature from "./components/home/CheckSignature";
import CheckInstruction from "./components/CheckInstruction";
import CreateInstructions from "./components/createInstructions";
import SignatureReports from "./components/reports/signature"
import AllReports from "./components/reports/allReports";
import PendingSignature from "./components/reports/pendingSignature";
import UserActivity from "./components/reports/userActivity";
import SearchReport from "./components/reports/search";
import Category from "./components/reports/category";
import {MyComponent} from "./components/typeForm"
import ViewInstructions from "./components/ViewInstructions";
import CreateDocument from "./components/documents/CreateDocument";
import CheckDocuments from "./components/documents/CheckDocuments";
import EditJob from "./components/jobs/editJob";
import EditCategory from "./components/categories/editCategory"
import Categories from "./components/categories/categories"
import EditSignature from "./components/home/editSignature"
import AddSignature from "./components/home/AddSignature";
import SearchSignatures from "./components/searchSignatures";
import Instructions from "./components/instructions/instructions";
import EditInstruction from "./components/instructions/editInstruction";
import Documents from "./components/documents/documents";
import EditDocuments from "./components/documents/editDocuments";


function App({ isAuth }) {

  const { t, i18n } = useTranslation();

  const [language, setLanguage] = useState(
    localStorage.getItem("lang") ?? "en"
  );

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language])
  // return (

  // );

  // let location = useLocation();


  return (
    <LanguageContext.Provider value={{ setLanguage, language }}>
      <div className="App"
        dir={language == "ar" ? "rtl" : null}
      >
        <Router>
          <>
            {isAuth ?
              <>
                <Header />
                <Sidebar />

                <div className="content">
                  <Route path="/scan" exact component={AddSignature} />
                  <Route path="/signatures" exact component={SearchSignatures} />
                  <Route path="/createBank" exact component={CreateBank} />
                  <Route path="/createUser" exact component={CreateUsers} />
                  <Route path="/create_jobs" exact component={CreateJobs} />
                  <Route path="/unverified_users" exact component={UnverifiedUsers} />
                  <Route path="/createBranch" exact component={CreateBranch} />
                  <Route path="/createCategory" exact component={CreateCategory} />
                  <Route exact path="/jobs" component={Jobs} />
                  <Route exact path="/edit_job/:id" component={EditJob} />
                  <Route exact path="/edit_category/:id" component={EditCategory} />
                  <Route exact path="/categories" component={Categories} /> 
                  <Route path="/checkCategories" exact component={CheckCategories} />
                  <Route path="/search" exact component={Search} />
                  <Route path="/checkSignature" exact component={CheckSignature} />
                  <Route path="/edit_signature/:id" exact component={EditSignature} />
                  <Route path="/checkInstructions" exact component={CheckInstruction} />
                  <Route path="/createInstruction" exact component={CreateInstructions} />
                  <Route path="/reports" exact component={AllReports} />
                  <Route path="/reports/signature_reports" exact component={SignatureReports} />
                  <Route path="/reports/pending_signature_reports" exact component={PendingSignature} />
                  <Route path="/reports/user_activity_reports" exact component={UserActivity} />
                  <Route path="/reports/search_reports" exact component={SearchReport} />
                  <Route path="/reports/category_reports" exact component={Category} /> 
                  <Route path="/typeForm" exact component={MyComponent} />
                  <Route path="/view_instructions/:id" exact component={ViewInstructions} />
                  <Route path="/createDocument" exact component={CreateDocument} />
                  <Route path="/checkDocuments" exact component={CheckDocuments} />
                  <Route path="/instructions" exact component={Instructions} />
                  <Route path="/edit_instructions/:id" exact component={EditInstruction} />
                  <Route path="/documents" exact component={Documents} />
                  <Route path="/edit_document/:id" exact component={EditDocuments} />

                  <Footer />
                </div>


              </>
              :
              <Route path="/" exact component={Login} />
            }

          </>
        </Router>
      </div>
    </LanguageContext.Provider>
  )
}

const mapStateToProps = (state) => ({
  isAuth: state.auth.isAuth,
});

export default connect(mapStateToProps, null)(App);
